import { defineComponent as _defineComponent } from 'vue';
import axios, {} from "axios";
import { BAlert, BButton, BForm, BFormCheckbox, BFormGroup } from "bootstrap-vue";
import { computed, onMounted, ref } from "vue";
import Multiselect from "vue-multiselect";
import { useConfig } from "@/composables/config";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import { capitalizeFirstLetter } from "@/utils/strings";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExternalLogin',
    props: {
        loginPage: { type: Boolean, default: false },
        excludeIdps: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        const { config, isConfigLoaded } = useConfig();
        const loading = ref(false);
        const messageText = ref(null);
        const messageVariant = ref(null);
        const cILogonIdps = ref([]);
        const selected = ref(null);
        const rememberIdp = ref(false);
        const cilogonOrCustos = ref(null);
        const toggleCilogon = ref(false);
        const oIDCIdps = computed(() => (isConfigLoaded.value ? config.value.oidc : {}));
        const filteredOIDCIdps = computed(() => {
            const exclude = ["cilogon", "custos"].concat(props.excludeIdps);
            const filtered = Object.assign({}, oIDCIdps.value);
            exclude.forEach((idp) => {
                delete filtered[idp];
            });
            return filtered;
        });
        const cilogonListShow = computed(() => {
            return oIDCIdps.value.cilogon || oIDCIdps.value.custos;
        });
        const cILogonEnabled = computed(() => oIDCIdps.value.cilogon);
        const custosEnabled = computed(() => oIDCIdps.value.custos);
        onMounted(async () => {
            rememberIdp.value = getIdpPreference() !== null;
            // Only fetch CILogonIDPs if custos/cilogon configured
            if (cilogonListShow.value) {
                await getCILogonIdps();
            }
        });
        function toggleCILogon(idp) {
            toggleCilogon.value = !toggleCilogon.value;
            cilogonOrCustos.value = toggleCilogon.value ? idp : null;
        }
        async function submitOIDCLogin(idp) {
            loading.value = true;
            try {
                const loginUrl = withPrefix(`/authnz/${idp}/login`);
                const urlParams = new URLSearchParams(window.location.search);
                const redirectParam = urlParams.get("redirect");
                const formData = new FormData();
                formData.append("next", redirectParam || "");
                const { data } = await axios.post(loginUrl, formData, { withCredentials: true });
                if (data.redirect_uri) {
                    window.location = data.redirect_uri;
                }
            }
            catch (e) {
                messageVariant.value = "danger";
                messageText.value = errorMessageAsString(e, "Login failed for an unknown reason.");
            }
            finally {
                loading.value = false;
            }
        }
        async function submitCILogon(idp) {
            if (props.loginPage) {
                setIdpPreference();
            }
            if (!selected.value || !idp) {
                messageVariant.value = "danger";
                messageText.value = "Please select an institution.";
                return;
            }
            loading.value = true;
            try {
                const { data } = await axios.post(withPrefix(`/authnz/${idp}/login/?idphint=${selected.value.EntityID}`));
                localStorage.setItem("galaxy-provider", idp);
                if (data.redirect_uri) {
                    window.location = data.redirect_uri;
                }
            }
            catch (e) {
                messageVariant.value = "danger";
                messageText.value = errorMessageAsString(e, "Login failed for an unknown reason.");
            }
            finally {
                loading.value = false;
            }
        }
        async function getCILogonIdps() {
            try {
                const { data } = await axios.get(withPrefix("/authnz/get_cilogon_idps"));
                cILogonIdps.value = data;
                if (cILogonIdps.value.length == 1) {
                    selected.value = cILogonIdps.value[0];
                }
                else {
                    // List is originally sorted by OrganizationName which can be different from DisplayName
                    cILogonIdps.value.sort((a, b) => (a.DisplayName > b.DisplayName ? 1 : -1));
                }
                if (props.loginPage) {
                    const preferredIdp = getIdpPreference();
                    if (preferredIdp) {
                        const selectedIdp = cILogonIdps.value.find((idp) => idp.EntityID === preferredIdp);
                        if (selectedIdp) {
                            selected.value = selectedIdp;
                        }
                    }
                }
            }
            catch (e) {
                const error = e;
                messageVariant.value = "danger";
                const message = error.response?.data && error.response.data.err_msg;
                messageText.value = message || "Failed to fetch CILogon IdPs.";
            }
        }
        function setIdpPreference() {
            if (rememberIdp.value && selected.value) {
                localStorage.setItem("galaxy-remembered-idp", selected.value.EntityID);
            }
            else {
                localStorage.removeItem("galaxy-remembered-idp");
            }
        }
        function getIdpPreference() {
            return localStorage.getItem("galaxy-remembered-idp");
        }
        return { __sfc: true, props, config, isConfigLoaded, loading, messageText, messageVariant, cILogonIdps, selected, rememberIdp, cilogonOrCustos, toggleCilogon, oIDCIdps, filteredOIDCIdps, cilogonListShow, cILogonEnabled, custosEnabled, toggleCILogon, submitOIDCLogin, submitCILogon, getCILogonIdps, setIdpPreference, getIdpPreference, BAlert, BButton, BForm, BFormCheckbox, BFormGroup, Multiselect, capitalizeFirstLetter, LoadingSpan };
    }
});
